<template>
  <ModalWrapper :prevent-closing="preventClosing" open @close="emitClose">
    <ModalContainer
      :title="title"
      :description="description"
      :variant-class-name="variantClassName"
      :prevent-closing="preventClosing"
      @close="emitClose"
    >
      <template #header>
        <slot name="header" :title="title" :description="description" />
      </template>
      <slot />
    </ModalContainer>
  </ModalWrapper>
</template>

<script lang="ts" setup>
  // Components
  import ModalContainer from '~/misc/modal/container/ModalContainer.vue';

  defineProps({
    title: {
      type: String,
      default: undefined,
    },
    description: {
      type: String,
      default: undefined,
    },
    preventClosing: {
      type: Boolean,
      default: false,
    },
    variantClassName: {
      type: String,
      default: undefined,
    },
  });

  const emit = defineEmits<{
    (e: 'close'): void;
  }>();

  const emitClose = () => emit('close');
</script>
